import { ApiProperty } from "@nestjs/swagger";

export class PlantZone {
    @ApiProperty()
    plantId:number;
    @ApiProperty()
    zoneId:number;
}